import { useDispatch, useSelector } from "react-redux"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import React, { memo } from "react"

import { closeDialog } from "src/features/Authentication/SessionExpiredDialog.ducks"

const OAUTH_LINK = process.env.REACT_APP_OAUTH_ENDPOINT
const CLIENT_ID = process.env.REACT_APP_OAUTH_CLIENT_ID

function SessionExpiredDialog() {
  const dispatch = useDispatch()
  const show = useSelector((state) => state.sessionExpiredDialog.show)

  const handleReloadClick = () => {
    dispatch(closeDialog())
    window.location.href = `${OAUTH_LINK}/login?client_id=${CLIENT_ID}`
  }

  return (
    <React.Fragment>
      <Dialog
        open={show}
        aria-labelledby="session-expire-alert-dialog-title"
        aria-describedby="session-expire-alert-dialog-description"
        // disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="session-expire-alert-dialog-title">
          Please sign in again
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="session-expire-alert-dialog-description">
            You were signed out of your account. Please press ‘Reload’ to sign
            in to the SHARMBLE Admin Mall again.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReloadClick} color="primary" autoFocus>
            Reload
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

export default memo(SessionExpiredDialog)
